import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldHalved, faSitemap, faStethoscope } from '@fortawesome/free-solid-svg-icons';

import { Reveal } from '../../../../components/Reveal/Reveal';
import { SectionHeader } from '../../../../components/SectionHeader/SectionHeader';

import ui from '../../../../styles/ui.module.css';
import st from './Goal.module.css';

export function Goal() {
  return (
    <section className={`${ui.section} ${ui.sectionSeam} ${st.root}`}>
      <div className={ui.container}>
        <Reveal>
          <SectionHeader
            kicker="Зачем"
            title="Основная цель курса"
            subtitle="Повышение эффективности применения ИИ-решений в здравоохранении — от стратегии до внедрения и контроля качества."
            align="center"
          />
        </Reveal>

        <div className={st.grid3}>
          <Reveal>
            <div className={`${ui.card} ${st.feature}`}>
              <div className={st.featureIcon}>
                <FontAwesomeIcon icon={faStethoscope} />
              </div>
              <div className={st.featureTitle}>Практика клинических сценариев</div>
              <div className={st.featureText}>Диагностика, лечение, снижение нагрузки и качество процессов.</div>
            </div>
          </Reveal>
          <Reveal delay={0.05}>
            <div className={`${ui.card} ${st.feature}`}>
              <div className={st.featureIcon}>
                <FontAwesomeIcon icon={faSitemap} />
              </div>
              <div className={st.featureTitle}>Внедрение и инфраструктура</div>
              <div className={st.featureText}>Региональные практики, контуры, алгоритм развёртывания решений.</div>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className={`${ui.card} ${st.feature}`}>
              <div className={st.featureIcon}>
                <FontAwesomeIcon icon={faShieldHalved} />
              </div>
              <div className={st.featureTitle}>Доверие, этика, информационная безопасность</div>
              <div className={st.featureText}>Метрики эффективности, преодоление скепсиса, правовые аспекты.</div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

